import { Dialog, Sheet } from "@gravity-ui/uikit";

import { ProductSamplesContent } from "../ProductSamplesContent";

interface ProductSamplesSheetProps {
  open: boolean;
  onClose: () => void;
}

export const ProductSamplesSheet = ({
  open,
  onClose,
}: ProductSamplesSheetProps) => {
  return (
    <Sheet allowHideOnContentScroll={false} visible={open} onClose={onClose}>
      <Dialog.Body>
        <ProductSamplesContent onClose={onClose} />
      </Dialog.Body>
    </Sheet>
  );
};
